import API from "../../apiConfig";

export const generateOTP = async (username,isWoSeller) => {
  const response = await API.post("user/seller/generateOtp",{username,isWoSeller},{ withCredentials: false });
  return response;
};
